import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.875 1.5C4.875 1.29289 5.04289 1.125 5.25 1.125H18.75C18.9571 1.125 19.125 1.29289 19.125 1.5V7.5C19.125 7.70711 18.9571 7.875 18.75 7.875C18.5429 7.875 18.375 7.70711 18.375 7.5V1.875H5.625V7.5C5.625 7.70711 5.45711 7.875 5.25 7.875C5.04289 7.875 4.875 7.70711 4.875 7.5V1.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.375 7.5C0.375 7.29289 0.542893 7.125 0.75 7.125H23.25C23.4571 7.125 23.625 7.29289 23.625 7.5V17.25C23.625 17.4571 23.4571 17.625 23.25 17.625H18.75C18.5429 17.625 18.375 17.4571 18.375 17.25C18.375 17.0429 18.5429 16.875 18.75 16.875H22.875V7.875H1.125V16.875H5.25C5.45711 16.875 5.625 17.0429 5.625 17.25C5.625 17.4571 5.45711 17.625 5.25 17.625H0.75C0.542893 17.625 0.375 17.4571 0.375 17.25V7.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.875 13.5C4.875 13.2929 5.04289 13.125 5.25 13.125H18.75C18.9571 13.125 19.125 13.2929 19.125 13.5V22.5C19.125 22.7071 18.9571 22.875 18.75 22.875H5.25C5.04289 22.875 4.875 22.7071 4.875 22.5V13.5ZM5.625 13.875V22.125H18.375V13.875H5.625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.375 10.5C18.375 10.2929 18.5429 10.125 18.75 10.125H20.25C20.4571 10.125 20.625 10.2929 20.625 10.5C20.625 10.7071 20.4571 10.875 20.25 10.875H18.75C18.5429 10.875 18.375 10.7071 18.375 10.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.875 16.5C7.875 16.2929 8.04289 16.125 8.25 16.125H15.75C15.9571 16.125 16.125 16.2929 16.125 16.5C16.125 16.7071 15.9571 16.875 15.75 16.875H8.25C8.04289 16.875 7.875 16.7071 7.875 16.5ZM7.875 19.5C7.875 19.2929 8.04289 19.125 8.25 19.125H15.75C15.9571 19.125 16.125 19.2929 16.125 19.5C16.125 19.7071 15.9571 19.875 15.75 19.875H8.25C8.04289 19.875 7.875 19.7071 7.875 19.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.75 10.125C3.54289 10.125 3.375 10.2929 3.375 10.5C3.375 10.7071 3.54289 10.875 3.75 10.875C3.95711 10.875 4.125 10.7071 4.125 10.5C4.125 10.2929 3.95711 10.125 3.75 10.125ZM2.625 10.5C2.625 9.87868 3.12868 9.375 3.75 9.375C4.37132 9.375 4.875 9.87868 4.875 10.5C4.875 11.1213 4.37132 11.625 3.75 11.625C3.12868 11.625 2.625 11.1213 2.625 10.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgPrint;
